import { MINUTE_MS } from '#shared';

/**
 * How often the client re-fetches the whole alert snapshot while connected.
 *
 * BE ARCH-010 records this tick as the client's defence against a missed
 * `cleared`: delivery is at-most-once, so a publish that fails after commit is
 * never retried and the client heals here or nowhere. The period is therefore a
 * staleness BOUND — the longest an already-cleared alert can remain on screen —
 * not a polling preference, and the socket still delivers transitions promptly
 * in the normal case.
 *
 * Five minutes matches `SILENCE_CHECK_INTERVAL_MS`, the only other interval in
 * the `nop-events` layer (377:E033).
 */
export const ALERT_SNAPSHOT_TICK_MS = 5 * MINUTE_MS;
